/** session_date is a bare YYYY-MM-DD — lib/date.js parses timestamps only. */
export function fmtDay(d) {
  if (!d) return ''
  const [y, m, day] = d.split('-').map(Number)
  const dt = new Date(y, m - 1, day)
  return Number.isNaN(dt.getTime())
    ? d
    : dt.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' })
}

/** updated_at is a UTC 'YYYY-MM-DD HH:MM:SS' — render the LOCAL day, or an
 *  evening edit reads as tomorrow. Returns '' for missing input. */
export function fmtEditedDay(ts) {
  if (!ts) return ''
  const dt = new Date(ts.replace(' ', 'T') + 'Z')
  if (Number.isNaN(dt.getTime())) return fmtDay(ts.slice(0, 10))
  return dt.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' })
}

/** Local YYYY-MM-DD of a UTC timestamp — for comparing against session_date. */
export function localDayOf(ts) {
  if (!ts) return ''
  const dt = new Date(ts.replace(' ', 'T') + 'Z')
  if (Number.isNaN(dt.getTime())) return ts.slice(0, 10)
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`
}

export function todayISO() {
  const t = new Date()
  return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`
}

/** In the Session Log everyone logs: the viewer/editor split governs CDM
 *  Information only (Charles, 2026-08-02). Signed in = can create here. */
export function useCanEdit(me) {
  return Boolean(me?.data?.user)
}

/** Guest tier (Charles, 2026-08-04): viewer-role accounts create but never
 *  revise — an EXISTING entry shows edit/delete affordances only when the
 *  server marked it `mine`. Editors+ keep the everyone-writes rule. */
export function canTouch(me, item) {
  const u = me?.data?.user
  if (!u) return false
  return u.role !== 'viewer' || Boolean(item?.mine)
}

/** "Cathleen Conte" → CC, "Charles de Montebello" → CM. First and last
 *  word, so particles don't hijack the badge. */
export function initials(name) {
  const words = String(name || '').trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return ''
  const first = words[0][0]
  const last = words.length > 1 ? words[words.length - 1][0] : ''
  return (first + last).toUpperCase()
}


/** The studio's mic locker, in Charles's order (2026-08-01). Hardcoded on
 *  purpose — if the list needs managing in-app, that's a dogfooding finding. */
export const MIC_PRESETS = [
  '416',
  'U87 (black)',
  'Mojave (black)',
  'Mojave (silver)',
  'MKH50',
  'U87 (silver)',
  'U87 (western)',
  'SM7',
  'CMIT5',
  'V4U',
  // Lavaliers (Charles, 2026-10-09).
  'COS-11D',
  'Countryman B3',
  'DPA',
]

export const SESSION_TYPES = ['Audiobook', 'Podcast', 'ADR', 'Commercial VO', 'Animation', 'Other']

export const ROOMS = ['Studio A', 'Studio B', 'Studio C', 'Studio 1', 'Studio 5']

export const SAMPLE_RATES = ['44.1kHz', '48kHz']
export const BIT_DEPTHS = ['16-bit', '24-bit', '32-bit float']

// The iOS keyboard trick is shared with the client page editor now.
export { primeKeyboard, adoptKeyboard } from '../../lib/keyboard.js'

/** "Edit goes to" is usually an email but sometimes an FTP address
 *  (Charles, 2026-08-06) — link whatever it is sensibly, or return null
 *  for plain text. */
export function deliveryHref(v) {
  if (!v) return null
  if (v.includes('@') && !v.includes('/')) return `mailto:${v}`
  if (/^[a-z][a-z0-9+.-]*:\/\//i.test(v)) return v // already a URL (ftp://, https://…)
  if (/^ftp\./i.test(v)) return `ftp://${v}`
  return null
}
